<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M16.3377 11.86L8.48775 19.71L7.77775 19L14.9277 11.85L7.77775 4.71004L8.48775 4.00004L16.3377 11.85V11.86Z"
      :class="colorClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.48775 3.64648L16.5877 11.7465V11.9636L8.48775 20.0636L7.4242 19L14.5741 11.8502L7.42407 4.71016L8.48775 3.64648ZM8.13143 4.70991L15.2814 11.8499L8.1313 19L8.48775 19.3565L15.9892 11.855L8.48775 4.35359L8.13143 4.70991Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
